import {
  KeychainAccess,
  SecureStorage,
} from '@aparajita/capacitor-secure-storage'
import { SimpleStorage } from './storageUtil'

export class RefreshTokenStorage extends SimpleStorage {
  set = async (value: string | null) => {
    try {
      if (value) {
        await SecureStorage.set(
          this.key,
          value,
          false,
          false,
          KeychainAccess.afterFirstUnlock,
        )
      } else {
        await SecureStorage.remove(this.key)
      }
      this.value = value
    } catch (err) {
      console.error('SecureStorage write failed', err)
      throw err
    }
  }

  load = async () => {
    this.value = ((await SecureStorage.get(this.key)) as string) ?? null
  }
}
